export default {
    //数字输入框最大值限制
    inputTofixed:function (el,binding,vnode){
        const target = el instanceof HTMLInputElement ? el : el.querySelector("input");
        target.addEventListener("input", e => { 
            if(e.target.value.indexOf('.')!=-1){//含点                
                if(e.target.value.toString().split(".")[1].length > 2){
                    e.target.value = Number(e.target.value).toFixed(2)
                }
            }
        })
    },
    
}


// WEBPACK FOOTER //
// ./src/utils/directive.js